<soft-ds-card density="none">
  <cdk-accordion>
    <cdk-accordion-item
      #accordionItem="cdkAccordionItem"
      [expanded]="expanded()"
      [attr.aria-expanded]="accordionItem.expanded"
      class="flex flex-col"
    >
      <div
        class="flex justify-between items-center cursor-pointer p-4"
        role="button"
        tabindex="0"
        (click)="accordionItem.toggle()"
        (keydown.enter)="accordionItem.toggle()"
        (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
      >
        <div class="flex items-center gap-2">
          <h6
            class="font-semibold text-light text-sm uppercase leading-wide tracking-wide"
          >
            {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.TITLE' | translate }}
          </h6>
          @if (data()?.stockAmount?.length) {
          <soft-ds-badge size="md" variant="outline">
            {{ data()!.stockAmount.length }}
          </soft-ds-badge>
          }
        </div>
        <div
          class="text-light bg-surface rounded-full p-3 m-1 cursor-pointer hover:bg-hover"
        >
          @if (!accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-down" />
          } @else {
          <soft-icon name="fa-regular fa-chevron-up" />
          }
        </div>
      </div>

      <div class="px-4 pb-4" [style.display]="accordionItem.expanded ? 'block' : 'none'">
        <div class="flex flex-col gap-3">
          @for (stockEntry of data()?.stockAmount; track stockEntry) {
          <soft-ds-card class="flex flex-col gap-3">
            <div class="flex items-center gap-3">
              <div
                class="border border-primary text-primary rounded-lg p-3 shrink-0 bg-primary-50 hover:bg-primary-100 hover:cursor-pointer"
                (click)="showBewegungen.emit({stockLocation: stockEntry})"
              >
                <soft-icon name="fa-regular fa-warehouse" />
              </div>
              <span class="font-semibold text-sm leading-snug flex-1 min-w-0">
                {{ stockEntry.stock?.title || stockEntry.stock?.name }}
              </span>
            </div>

            <div class="grid grid-cols-2 gap-2">
              <div class="flex flex-col gap-1 bg-surface-secondary rounded-lg px-3 py-2">
                <span class="text-xs font-semibold text-light uppercase tracking-wide">
                  {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.AMOUNT' | translate }}
                </span>
                <span class="font-bold text-sm">
                  {{ stockEntry.amount | number: '1.2-2' }} {{ stockEntry?.itemUnit?.name
                  }}
                </span>
              </div>
              <div class="flex flex-col gap-1 bg-surface-secondary rounded-lg px-3 py-2">
                <span class="text-xs font-semibold text-light uppercase tracking-wide">
                  {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.DISPO' | translate }}
                </span>
                <span class="font-bold text-sm">
                  {{ stockEntry.amount - stockEntry.reserved + stockEntry.orders | number:
                  '1.2-2' }} {{ stockEntry?.itemUnit?.name }}
                </span>
              </div>
            </div>

            <div class="flex items-center gap-2 text-light text-xs">
              <soft-icon name="fa-regular fa-truck" />
              <span>
                {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.ORDER_AMOUNT' | translate }} {{
                stockEntry?.orders || 0 | number: '1.2-2' }} {{ stockEntry?.itemUnit?.name
                }}
              </span>
            </div>

            @if (showNextOrderDate() && stockEntry?.nextOrderDeliveryDate) {
            <div class="flex items-center gap-2 text-light text-xs">
              <soft-icon name="fa-regular fa-calendar" />
              <span>
                {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.NEXT_DELIVERY' | translate |
                interpolate : { date: $safeNavigationMigration(stockEntry?.nextOrderDeliveryDate) | format:
                'DATE.DEFAULT' } }}
              </span>
            </div>
            }
          </soft-ds-card>
          }
        </div>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>
</soft-ds-card>
